import { render, staticRenderFns } from "./QRCodeLink.vue?vue&type=template&id=770ef095&"
import script from "./QRCodeLink.vue?vue&type=script&lang=js&"
export * from "./QRCodeLink.vue?vue&type=script&lang=js&"
import style0 from "./QRCodeLink.vue?vue&type=style&index=0&id=770ef095&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports